export var BG_COLORS = {
  white: 'white',
  grey: 'var(--chakra-colors-grey-100, #EEEDE9)',
  yellow: 'var(--chakra-colors-yellow-500, #FFDC00)',
  transparent: 'transparent',
  undefined: 'transparent',
  null: 'transparent'
};
export var CTA_VARIANTS = {
  none: 'none',
  primary: 'primary',
  'primary button': 'primary',
  secondary: 'secondary',
  'secondary button': 'secondary',
  'large-button': 'primary',
  'small-button': 'tertiarySmall',
  link: 'iconLink',
  iconLink: 'iconLink',
  'icon link': 'iconLink'
};
export var COLOR_RED = '#E20019';